import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from './../images/Insaf-Logo.png';
import 'animate.css';
import LanguageSelector from './LanguageSelector'; // Import LanguageSelector component

const Header = ({ language, content, onSelectLanguage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const isRTL = language === 'ar'; // Check if language is Arabic

  return (
    <nav className="bg-transparent fixed z-50 w-full">
      <div className="  w-full">
        <div className="flex justify-between pl-0 md:pl-8 pr-5 md:pr-16 items-center h-16"  dir={isRTL ? "rtl" : "ltr"}>
          <div className="flex items-center justify-center w-full">
            <Link to='/' className='w-9/12 sm:w-1/3'>
              <img className="block h-10 w-auto" src={logo} alt="Logo" />
            </Link>
         
          <div className="hidden sm:flex justify-center items-center space-x-8 w-2/3 ">
            <HeaderLinks content={content} isRTL={isRTL} onClick={handleClick} className='w-1/2' />
         </div>
         <div className='w-1/12 hidden sm:flex'>
              <LanguageSelector onSelectLanguage={onSelectLanguage} onClick={handleClick} />
  
</div> 
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <button
              onClick={toggleNavbar}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className={`${isOpen ? 'block sm:hidden open' : 'hidden closed'} sm:flex-col z-10 w-full bg-zinc-800 animate__animated animate__fadeInDown`} id="mobile-menu">
        <div className="w-full px-2 pt-2 pb-3 space-y-1 flex flex-col p-4">
          <HeaderLinks content={content} />
          <div className="flex sm:hidden p-2  space-x-8 w-full">
            <LanguageSelector onSelectLanguage={onSelectLanguage} />
          </div>
        </div>
      </div>
    </nav>
  );
};

const HeaderLinks = ({ content, isRTL, onClick }) => {
  const location = useLocation();
  const links = [
    { to: '/', label: content.header.home },
    { to: '/about', label: content.header.about },
    { to: '/products', label: content.header.products },
    { to: '/contact', label: content.header.contact },
  ];

  return (
    <ul className="flex flex-col sm:flex-row p-5 space-y-4 sm:space-y-0 sm:space-x-8">
      {isRTL ? (
        links.reverse().map((link, index) => (
          <li key={index}>
            <NavLink
              to={link.to}
              onClick={onClick}
              className={`text-gray-300 hover:bg-gray-700 hover:text-white rounded-md text-sm font-medium p-3 ${location.pathname === link.to ? 'text-red-600' : ''}`}
            >
              {link.label}
            </NavLink>
          </li>
        ))
      ) : (
        links.map((link, index) => (
          <li key={index}>
            <NavLink
              to={link.to}
              onClick={onClick}
              className={`text-gray-300 hover:bg-gray-700 hover:text-white rounded-md text-sm font-medium p-3 ${location.pathname === link.to ? 'text-red-600' : ''}`}
            >
              {link.label}
            </NavLink>
          </li>
        ))
      )}
    </ul>
  );
};

export default Header;
